import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/index/home.vue";
import Index from "../views/Index.vue";

//医院概况
import YYGKINDEX from "../views/yygk/home.vue";
import YYGK from "../views/yygk/index.vue";
import YYGKARTICLE from "../views/yygk/article.vue";
import XIANREN from "../views/yygk/xianren.vue";
import YIYUANRONGYU from "../views/yygk/yiyuanrongyu.vue";
import RENCAIPEIYANG from "../views/yygk/rencaipeiyang.vue";
import LIANMENG from "../views/yygk/lianmeng.vue";
import LIANMENGARTICLE from "../views/yygk/lianmeng_article.vue";
import MANYI from "../views/yygk/manyi.vue";

//医疗特色
import YLTSINDEX from "../views/ylts/home.vue";

import SEARCH from "../views/ylts/search.vue";
import KESHILIST from "../views/ylts/keshi_list.vue";
import KEARTICLE from "../views/ylts/keshi_article.vue";
import MINGYIARTICLE from "../views/ylts/mingyi_article.vue";
import YHULI from "../views/ylts/huli.vue";
import YHULIARTICLE from "../views/ylts/huli_article.vue";
import TESE from "../views/ylts/tese.vue";
import TESEARTICLE from "../views/ylts/tese_article.vue";
import MINGYI from "../views/ylts/mingyi.vue";
import MINGYIKSLIST from "../views/ylts/mingyi_list.vue";
import MINGYIDETAIL from "../views/ylts/mingyi_detail.vue";
import ZHUANKE from "../views/ylts/zhuanke.vue";
import ZHUANKEARTICLE from "../views/ylts/zhuanke_article.vue";

//教学科研
import JXKYINDEX from "../views/jxky/home.vue";
import BYHYXJY from "../views/jxky/byhyxjy.vue";
import TRAINING from "../views/jxky/training"
import PROFESSIONAL from "../views/jxky/professional"
import PROFESSIONALARTICLE from "../views/jxky/professional_article"
import DYNAMIC from "../views/jxky/dynamic"
import DYNAMICARTICLE from "../views/jxky/dynamic_article"

import GONGZUO from "../views/jxky/gongzuo.vue";
import YANJIUSHENG from "../views/jxky/yanjiusheng.vue";

import YANJIUSHENGXUEKE from "../views/jxky/yanjiusheng_xueke.vue";
import YANJIUSHENGDAOSHI from "../views/jxky/yanjiusheng_daoshi.vue";

import XUESHU from "../views/jxky/xueshu.vue";
import XUESHUARTICLE from "../views/jxky/xueshu_article.vue";

import ZAZHI from "../views/jxky/zazhi.vue";
import ZAZHIARTICLE from "../views/jxky/zazhi_article.vue";

import ZDSYS from "../views/jxky/zdsys.vue";
import ZDSYSARTICLE from "../views/jxky/zdsys_article.vue";

import LLWYH from "../views/jxky/llwyh.vue";
import LLWYHARTICLE from "../views/jxky/llwyh_article.vue";

import YWLCSYJG from "../views/jxky/ywlcsyjg.vue";
import YWLCSYJGARTICLE from "../views/jxky/ywlcsyjg_article.vue";
//盛京文化
import SJWHINDEX from "../views/sjwh/home.vue";
import SJWH from "../views/sjwh/index.vue";
import SJWHARTICLE from "../views/sjwh/index_article.vue";
import SJWHARTICLEHUNDRED from "../views/sjwh/index_hundredarticle.vue";
import YUANGE from "../views/sjwh/yuange.vue";
import ZHOUKAN from "../views/sjwh/zhoukan.vue";
import ZHOUKANLIST from "../views/sjwh/zhoukan_list.vue";
import ZHOUKANARTICLE from "../views/sjwh/zhoukan_article.vue";
import TV from "../views/sjwh/tv.vue";
import TVBEFORE from "../views/sjwh/tv_before.vue";
import YINGXIANG from "../views/sjwh/yingxiang.vue";
import GUSHI from "../views/sjwh/gushi.vue"; //end

//志愿服务

// import ZYFWINDEX from "../views/zyfw/home.vue";
// import ZYFW from "../views/zyfw/index.vue";
// import JIARU from "../views/zyfw/jiaru.vue";
// import DANHANG from "../views/zyfw/daohang.vue";
// import ZHIDU from "../views/zyfw/zhidu.vue";
// import GANYAN from "../views/zyfw/ganyan.vue";
// import XIANGCE from "../views/zyfw/xiangce.vue";
// import ZYFWARTICLE from "../views/zyfw/article.vue";

//健康教育
import JKJY from "../views/jkjy/index.vue";
import JKJYARTICLE from "../views/jkjy/article.vue";
import JKJYWAIKE from "../views/jkjy/waike.vue";
import JKJYFUCHANKE from "../views/jkjy/fuchan.vue";
import JKJYERKE from "../views/jkjy/erke.vue";
import JKJYGANRANKE from "../views/jkjy/ganranke.vue";
import JKJYZHONGYIKE from "../views/jkjy/zhongyike.vue";
import JKJYWUGUANKE from "../views/jkjy/wuguanke.vue";
import JKJYXINLIKE from "../views/jkjy/xinlike.vue";
import JKJYYIFU from "../views/jkjy/yifu.vue";
import JKJYQITA from "../views/jkjy/qita.vue";

//盛京看点
import SJKDINDEX from "../views/sjkd/index.vue";
import SJKDARTICLE from "../views/sjkd/article.vue";
import YLZHINDEX from "../views/sjkd/ylzh/index.vue"; //医疗纵横
import YLZHARTICLE from "../views/sjkd/ylzh/article.vue";
import YYGGLIST from "../views/sjkd/yygg/index.vue"; //医院公告
import YYGGARTICLE from "../views/sjkd/yygg/article.vue";
import ZBGGINDEX from "../views/sjkd/zbgg/index.vue"; //招标公告
import ZBARTICLE from "../views/sjkd/zbgg/zb_article.vue";
import CPARTICLE from "../views/sjkd/zbgg/cp_article.vue";
import ZBLIST from "../views/sjkd/zbgg/zb_list.vue";
import YJSINDEX from "../views/sjkd/yjszl/index.vue"; //预决算专栏
import YJSARTICLE from "../views/sjkd/yjszl/article.vue";
import MTKSJINDEX from "../views/sjkd/mtksj/index.vue"; //媒体看盛京
import MTKSJARTICLE from "../views/sjkd/mtksj/article.vue";
import ZTJYINDEX from "../views/sjkd/ztjy/index.vue"; //主题教育
import ZTJYARTICLE from "../views/sjkd/ztjy/article.vue";

// 自定义导航
import NAVONE from "../views/navone/index.vue";
import NAVONEARTICLE from "../views/navone/article.vue";
import NAVTWO from "../views/navtwo/index.vue";
import NAVTWOARTICLE from "../views/navtwo/article.vue";

// 联系我们
import DEAN from "../views/lxwm/dean/article.vue";
import LETTERSlIST from "../views/lxwm/letters/index.vue";
import LETTERSDETAIL from "../views/lxwm/letters/article.vue";
import DIGESTlIST from "../views/lxwm/digest/index.vue";
import DIGESTDETAIL from "../views/lxwm/digest/article.vue";
import REPLYlIST from "../views/lxwm/reply/index.vue";
import REPLYDETAIL from "../views/lxwm/reply/article.vue";
import DISCIPLINElIST from "../views/lxwm/discipline/index.vue";
import DISCIPLINEDETAIL from "../views/lxwm/discipline/article.vue";

import JYZN from "../views/jyzn/index.vue";
import LIUCHENG from "../views/jyzn/liucheng.vue";
import FENBU from "../views/jyzn/fenbu.vue";
import FENBUARTICLE from "../views/jyzn/fenbu_article.vue";
import LUXIAN from "../views/jyzn/luxian.vue";
import LIANXI from "../views/jyzn/lianxi.vue";

Vue.use(VueRouter);

var routes = [
  {
    path: "/",
    component: Index,
    children: [
      // 首页
      {
        path: "/",
        name: "Home",
        meta: {
          activeIndex: "0",
        },
        component: Home,
      },
      //医院概况
      {
        path: "/yygk/home",
        name: "YYGKINDEX",
        meta: {
          activeIndex: "1",
        },
        component: YYGKINDEX,
      },
      {
        path: "/yygk",
        name: "YYGK",
        meta: {
          activeIndex: "1",
        },
        component: YYGKINDEX,
      },
      {
        path: "/yygk/article",
        name: "YYGKARTICLE",
        meta: {
          activeIndex: "1",
        },
        component: YYGKARTICLE,
      },
      // 15 现任领导
      {
        path: "/yygk/xianren",
        name: "XIANREN",
        meta: {
          activeIndex: "1",
        },
        component: XIANREN,
      },
      // 16 医院荣誉
      {
        path: "/yygk/yiyuanrongyu",
        name: "YIYUANRONGYU",
        meta: {
          activeIndex: "1",
        },
        component: YIYUANRONGYU,
      },
      // 17 人才培养
      {
        path: "/yygk/rencaipeiyang",
        name: "RENCAIPEIYANG",
        meta: {
          activeIndex: "1",
        },
        component: RENCAIPEIYANG,
      },
      // 18 盛京医疗联盟
      {
        path: "/yygk/lianmeng",
        name: "LIANMENG",
        meta: {
          activeIndex: "1",
        },
        component: LIANMENG,
      },
      {
        path: "/yygk/lianmeng/article",
        name: "LIANMENGARTICLE",
        meta: {
          activeIndex: "1",
        },
        component: LIANMENGARTICLE,
      },

      // 19 第三方满意度调查
      {
        path: "/yygk/manyi",
        name: "MANYI",
        meta: {
          activeIndex: "1",
        },
        component: MANYI,
      },
      // 医疗特色
      {
        path: "/ylts/home",
        name: "Ylts",
        meta: {
          activeIndex: "2",
        },
        component: YLTSINDEX,
      },

      {
        path: "/ylts/kslist/:id",
        name: "KESHILIST",
        meta: {
          activeIndex: "2",
        },
        component: KESHILIST,
      },
      {
        path: "/ylts/kslist/article/:id",
        name: "KESHIARTICLE",
        meta: {
          activeIndex: "2",
        },
        component: KEARTICLE,
      },
      {
        path: "/ylts/mingyi/article/:id",
        name: "MINGYIARTICLE",
        meta: {
          activeIndex: "2",
        },
        component: MINGYIARTICLE,
      },

      {
        path: "/ylts/mingyi",
        name: "MINGYI",
        meta: {
          activeIndex: "2",
        },
        component: MINGYI,
      },

      {
        path: "/ylts/mingyi/kslist/:id",
        name: "MINGYIKSLIST",
        meta: {
          activeIndex: "2",
        },
        component: MINGYIKSLIST,
      },
      {
        path: "/ylts/mingyi/doctor/:id",
        name: "MINGYIDETAIL",
        meta: {
          activeIndex: "2",
        },
        component: MINGYIDETAIL,
      },
      {
        path: "/ylts/zhuanke",
        name: "ZHUANKE",
        meta: {
          activeIndex: "2",
        },
        component: ZHUANKE,
      },
      {
        path: "/ylts/zhuanke/article",
        name: "ZHUANKEARTICLE",
        meta: {
          activeIndex: "2",
        },
        component: ZHUANKEARTICLE,
      },
      {
        path: "/ylts/tese",
        name: "TESE",
        meta: {
          activeIndex: "2",
        },
        component: TESE,
      },
      {
        path: "/ylts/tese/article",
        name: "TESEARTICLE",
        meta: {
          activeIndex: "2",
        },
        component: TESEARTICLE,
      },
      {
        path: "/ylts/huli",
        name: "YHULI",
        meta: {
          activeIndex: "2",
        },
        component: YHULI,
      },
      {
        path: "/ylts/huli/article",
        name: "YHULIARTICLE",
        meta: {
          activeIndex: "2",
        },
        component: YHULIARTICLE,
      },

      {
        path: "/ylts/search",
        name: "SEARCH",
        meta: {
          activeIndex: "2",
        },
        component: SEARCH,
      },

      // 教学科研  begin
      {
        path: "/jxky/home",
        name: "JXKY",
        meta: {
          activeIndex: "3",
        },
        component: JXKYINDEX,
      },
      // {
      //   path: "/jxky",
      //   name: "JXKY",
      //   meta: {
      //     activeIndex: "3",
      //   },
      //   component: JXKYINDEX,
      // },
      {
        path: "/jxky/byhyxjy",
        name: "BYHYXJY",
        meta: {
          activeIndex: "3",
        },
        component: BYHYXJY,
      },
      {
        path: "/jxky/training",
        name: "TRAINING",
        meta: {
          activeIndex: "3",
        },
        component: TRAINING,
      },
      {
        path: "/jxky/professional",
        name: "PROFESSIONAL",
        meta: {
          activeIndex: "3",
        },
        component: PROFESSIONAL,
      },
      {
        path: "/jxky/professional/article/:id",
        name: "PROFESSIONALARTICLE",
        component: PROFESSIONALARTICLE,
        meta: {
          activeIndex: "3",
        },
      },
      {
        path: "/jxky/dynamic",
        name: "DYNAMIC",
        meta: {
          activeIndex: "3",
        },
        component: DYNAMIC,
      },
      {
        path: "/jxky/dynamic/article",
        name: "DYNAMICARTICLE",
        meta: {
          activeIndex: "3",
        },
        component: DYNAMICARTICLE,
      },
      {
        path: "/jxky/yanjiusheng",
        name: "YANJIUSHENG",
        meta: {
          activeIndex: "3",
        },
        component: YANJIUSHENG,
      },
      {
        path: "/jxky/yanjiusheng/xueke",
        name: "YANJIUSHENGXUEKE",
        meta: {
          activeIndex: "3",
        },
        component: YANJIUSHENGXUEKE,
      },
      {
        path: "/jxky/yanjiusheng/daoshi",
        name: "YANJIUSHENGDAOSHI",
        meta: {
          activeIndex: "3",
        },
        component: YANJIUSHENGDAOSHI,
      },
      {
        path: "/jxky/xueshu",
        name: "XUESHU",
        meta: {
          activeIndex: "3",
        },
        component: XUESHU,
      },
      {
        path: "/jxky/xueshu/article",
        name: "XUESHUARTICLE",
        meta: {
          activeIndex: "3",
        },
        component: XUESHUARTICLE,
      },
      {
        path: "/jxky/zazhi",
        name: "ZAZHI",
        meta: {
          activeIndex: "3",
        },
        component: ZAZHI,
      },
      {
        path: "/jxky/zazhi/article",
        name: "ZAZHIARTICLE",
        meta: {
          activeIndex: "3",
        },
        component: ZAZHIARTICLE,
      },

      {
        path: "/jxky/zdsys",
        name: "ZDSYS",
        meta: {
          activeIndex: "3",
        },
        component: ZDSYS,
      },
      {
        path: "/jxky/zdsys/article",
        name: "ZDSYSARTICLE",
        meta: {
          activeIndex: "3",
        },
        component: ZDSYSARTICLE,
      },
      {
        path: "/jxky/llwyh",
        name: "LLWYH",
        meta: {
          activeIndex: "3",
        },
        component: LLWYH,
      },

      {
        path: "/jxky/llwyh/article",
        name: "LLWYHARTICLE",
        meta: {
          activeIndex: "3",
        },
        component: LLWYHARTICLE,
      },
      {
        path: "/jxky/ywlcsyjg",
        name: "YWLCSYJG",
        meta: {
          activeIndex: "3",
        },
        component: YWLCSYJG,
      },
      {
        path: "/jxky/ywlcsyjg/article",
        name: "YWLCSYJGARTICLE",
        meta: {
          activeIndex: "3",
        },
        component: YWLCSYJGARTICLE,
      },

      // 盛京文化  begin
      {
        path: "/sjwh/home",
        name: "SJWHINDEX",
        meta: {
          activeIndex: "4",
        },
        component: SJWHINDEX,
      },
      {
        path: "/sjwh",
        name: "SJWH",
        meta: {
          activeIndex: "4",
        },
        component: SJWH,
      },
      {
        path: "/sjwh/article",
        name: "SJWHARTICLE",
        meta: {
          activeIndex: "4",
        },
        component: SJWHARTICLE,
      },
      {
        path: "/sjwh/article/hundred", // 百年历程
        name: "SJWHARTICLEHUNDRED",
        meta: {
          activeIndex: "4",
        },
        component: SJWHARTICLEHUNDRED,
      },
      {
        path: "/sjwh/yuange",
        name: "YUANGE",
        meta: {
          activeIndex: "4",
        },
        component: YUANGE,
      },

      {
        path: "/sjwh/tv",
        name: "TV",
        meta: {
          activeIndex: "4",
        },
        component: TV,
      },
      {
        path: "/sjwh/tv/before",
        name: "TVBEFORE",
        meta: {
          activeIndex: "4",
        },
        component: TVBEFORE,
      },
      {
        path: "/sjwh/yingxiang",
        name: "YINGXIANG",
        meta: {
          activeIndex: "4",
        },
        component: YINGXIANG,
      },
      {
        path: "/sjwh/gushi",
        name: "GUSHI",
        meta: {
          activeIndex: "4",
        },
        component: GUSHI,
      },
      // end
      // 志愿服务 begin
      // {
      //   path: "/zyfw/home",
      //   name: "ZYFWINDEX",
      //   meta: {
      //     activeIndex: "5",
      //   },
      //   component: ZYFWINDEX,
      // },
      // {
      //   path: "/zyfw",
      //   name: "ZYFW",
      //   meta: {
      //     activeIndex: "5",
      //   },
      //   component: ZYFW,
      // },

      // {
      //   path: "/zyfw/daohang",
      //   name: "DANHANG",
      //   meta: {
      //     activeIndex: "5",
      //   },
      //   component: DANHANG,
      // },
      // {
      //   path: "/zyfw/daohang/article",
      //   name: "DANHANGARTICLE",
      //   meta: {
      //     activeIndex: "5",
      //   },
      //   component: ZYFWARTICLE,
      // },
      // {
      //   path: "/zyfw/zhidu",
      //   name: "ZHIDU",
      //   meta: {
      //     activeIndex: "5",
      //   },
      //   component: ZHIDU,
      // },
      // {
      //   path: "/zyfw/zhidu/article",
      //   name: "ZHIDUARTICLE",
      //   meta: {
      //     activeIndex: "5",
      //   },
      //   component: ZYFWARTICLE,
      // },

      // {
      //   path: "/zyfw/ganyan",
      //   name: "GANYAN",
      //   meta: {
      //     activeIndex: "5",
      //   },
      //   component: GANYAN,
      // },
      // {
      //   path: "/zyfw/ganyan/article",
      //   name: "GANYANARTICLE",
      //   meta: {
      //     activeIndex: "5",
      //   },
      //   component: ZYFWARTICLE,
      // },
      // {
      //   path: "/zyfw/xiangce",
      //   name: "XIANGCE",
      //   meta: {
      //     activeIndex: "5",
      //   },
      //   component: XIANGCE,
      // },
      // {
      //   path: "/zyfw/xiangce/article",
      //   name: "ZYFWARTICLE",
      //   meta: {
      //     activeIndex: "5",
      //   },
      //   component: ZYFWARTICLE,
      // },
      // {
      //   path: "/zyfw/jiaru",
      //   name: "JIARU",
      //   meta: {
      //     activeIndex: "5",
      //   },
      //   component: JIARU,
      // },
      // {
      //   path: "/zyfw/jiaru/article",
      //   name: "JIARUARTICLE",
      //   meta: {
      //     activeIndex: "5",
      //   },
      //   component: ZYFWARTICLE,
      // },
      // end
      //盛京看点
      {
        path: "/sjkd",
        name: "SJKDINDEX",
        component: SJKDINDEX,
      },
      {
        path: "/sjkd/article",
        name: "SJKDARTICLE",
        component: SJKDARTICLE,
      },
      //医院公告
      {
        path: "/sjkd/yygg",
        name: "YYGGLIST",
        component: YYGGLIST,
      },
      {
        path: "/sjkd/yygg/article",
        name: "YYGGARTICLE",
        component: YYGGARTICLE,
      },
      //招标公告
      {
        path: "/sjkd/zbgg",
        name: "ZBGGINDEX",
        component: ZBGGINDEX,
      },
      {
        path: "/sjkd/zbgg/list",
        name: "ZBLIST",
        component: ZBLIST,
      },
      {
        path: "/sjkd/zbgg/article/zb",
        name: "ZBARTICLE",
        component: ZBARTICLE,
      },
      {
        path: "/sjkd/zbgg/article/cp",
        name: "CPARTICLE",
        component: CPARTICLE,
      },
      //预决算专栏
      {
        path: "/sjkd/yjszl",
        name: "YJSINDEX",
        component: YJSINDEX,
      },
      {
        path: "/sjkd/yjszl/article",
        name: "YJSARTICLE",
        component: YJSARTICLE,
      },
      //媒体看盛京
      {
        path: "/sjkd/mtksj",
        name: "MTKSJINDEX",
        component: MTKSJINDEX,
      },
      {
        path: "/sjkd/mtksj/article",
        name: "MTKSJARTICLE",
        component: MTKSJARTICLE,
      },
      //医疗纵横
      {
        path: "/sjkd/ylzh",
        name: "YLZHINDEX",
        component: YLZHINDEX,
      },
      {
        path: "/sjkd/ylzh/article/:id",
        name: "YLZHARTICLE",
        component: YLZHARTICLE,
      },

      //主题教育
      {
        path: "/sjkd/ztjy",
        name: "ZTJYINDEX",
        component: ZTJYINDEX,
      },
      {
        path: "/sjkd/ztjy/article",
        name: "ZTJYARTICLE",
        component: ZTJYARTICLE,
      },
      //联系我们 给院长写信
      {
        path: "/lxwm/dean",
        name: "dean",
        component: DEAN,
      },
      //联系我们 来信统计
      {
        path: "/lxwm/letters",
        name: "lettersList",
        component: LETTERSlIST,
      },
      {
        path: "/lxwm/letters/article",
        name: "lettersDetail",
        component: LETTERSDETAIL,
      },
      //联系我们 来信选登
      {
        path: "/lxwm/digest",
        name: "digestList",
        component: DIGESTlIST,
      },
      {
        path: "/lxwm/digest/article",
        name: "digestDetail",
        component: DIGESTDETAIL,
      },
      //联系我们 来信回复
      {
        path: "/lxwm/reply",
        name: "replyList",
        component: REPLYlIST,
      },
      {
        path: "/lxwm/reply/article",
        name: "replyDetail",
        component: REPLYDETAIL,
      },
      //联系我们 纪检监察
      {
        path: "/lxwm/discipline",
        name: "disciplineList",
        component: DISCIPLINElIST,
      },
      {
        path: "/lxwm/discipline/article",
        name: "disciplineDetail",
        component: DISCIPLINEDETAIL,
      },
      // 健康教育
      // {
      //   path: "/jkjy",
      //   name: "JKJY",
      //   meta: {
      //     activeIndex: "6",
      //   },
      //   component: JKJY,
      // },
      // {
      //   path: "/jkjy/article",
      //   name: "JKJYARTICLE",
      //   meta: {
      //     activeIndex: "6",
      //   },
      //   component: JKJYARTICLE,
      // },
      // {
      //   path: "/jkjy/waike",
      //   name: "JKJY",
      //   meta: {
      //     activeIndex: "6",
      //   },
      //   component: JKJYWAIKE,
      // },

      // {
      //   path: "/jkjy/fuchanke",
      //   name: "JKJY",
      //   meta: {
      //     activeIndex: "6",
      //   },
      //   component: JKJYFUCHANKE,
      // },

      // {
      //   path: "/jkjy/erke",
      //   name: "JKJY",
      //   meta: {
      //     activeIndex: "6",
      //   },
      //   component: JKJYERKE,
      // },

      // {
      //   path: "/jkjy/ganranke",
      //   name: "JKJY",
      //   meta: {
      //     activeIndex: "6",
      //   },
      //   component: JKJYGANRANKE,
      // },

      // {
      //   path: "/jkjy/zhongyike",
      //   name: "JKJY",
      //   meta: {
      //     activeIndex: "6",
      //   },
      //   component: JKJYZHONGYIKE,
      // },

      // {
      //   path: "/jkjy/wuguanke",
      //   name: "JKJY",
      //   meta: {
      //     activeIndex: "6",
      //   },
      //   component: JKJYWUGUANKE,
      // },

      // {
      //   path: "/jkjy/xinlike",
      //   name: "JKJY",
      //   meta: {
      //     activeIndex: "6",
      //   },
      //   component: JKJYXINLIKE,
      // },

      // {
      //   path: "/jkjy/yifu",
      //   name: "JKJY",
      //   meta: {
      //     activeIndex: "6",
      //   },
      //   component: JKJYYIFU,
      // },

      // {
      //   path: "/jkjy/qita",
      //   name: "JKJY",
      //   meta: {
      //     activeIndex: "6",
      //   },
      //   component: JKJYQITA,
      // },

      // 就医指南 begin
      {
        path: "/jyzn",
        name: "JYZN",
        component: JYZN,
      },
      {
        path: "/jyzn/liucheng",
        name: "LIUCHENG",
        component: LIUCHENG,
      },
      {
        path: "/jyzn/fenbu",
        name: "FENBU",
        component: FENBU,
      },
      {
        path: "/jyzn/fenbu/article/:id",
        name: "FENBUARTICLE",
        component: FENBUARTICLE,
      },

      {
        path: "/jyzn/luxian",
        name: "LUXIAN",
        component: LUXIAN,
      },
      {
        path: "/jyzn/lianxi",
        name: "LIANXI",
        component: LIANXI,
      },
      {
        path: "/nav/one",
        name: "NAVONE",
        component: NAVONE,
        meta: {
          activeIndex: "7",
        },
      },
      {
        path: "/nav/one/article",
        name: "NAVONEARTICLE",
        component: NAVONEARTICLE,
        meta: {
          activeIndex: "7",
        },
      },
      {
        path: "/nav/two",
        name: "NAVTWO",
        component: NAVTWO,
        meta: {
          activeIndex: "8",
        },
      },
      {
        path: "/nav/two/article",
        name: "NAVTWOARTICLE",
        component: NAVTWOARTICLE,
        meta: {
          activeIndex: "8",
        },
      },
      {
        path: "/sjwh/zhoukan",
        name: "ZHOUKAN",
        meta: {
          activeIndex: "4",
        },
        component: ZHOUKAN,
      },
      {
        path: "/sjwh/zhoukan/list",
        name: "ZHOUKANLIST",
        component: ZHOUKANLIST,
      },
      {
        path: "/sjwh/zhoukan/article",
        name: "ZHOUKANARTICLE",
        component: ZHOUKANARTICLE,
      },
    ],
  },
];

var router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

var originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
router.beforeEach((to, from, next) => {
  next();
});
router.afterEach((to, from, next) => { });

export default router;
